import { WebStorageStateStore } from 'oidc-client-ts'
import { ReactNode } from 'react'
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'

const { REACT_APP_COGNITO_AUTHORITY, REACT_APP_COGNITO_CLIENT_ID, REACT_APP_COGNITO_REDIRECT_URI } =
  process.env

const oidcConfig = {
  authority: REACT_APP_COGNITO_AUTHORITY,
  client_id: REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: REACT_APP_COGNITO_REDIRECT_URI,
  response_type: 'code',
  scope: 'phone openid email',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

interface Props {
  children: ReactNode
}

export const AuthProvider = ({ children }: Props) => {
  return <OidcAuthProvider {...oidcConfig}>{children}</OidcAuthProvider>
}
